export enum OrganizationMemberInvitationSteps {
  USER = 'USER',
  ROLE = 'ROLE',
  GROUP = 'GROUP',
  CARTRIDGE = 'CARTRIDGE',
}
